import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from "../../../../shared/models/user";
import { UserGroup } from "../../../../shared/models/user-group";
import { SearchedUserPipe } from "./searched-user.pipe";
import {applicationType} from "../team-users.component";

@Component({
    selector: 'app-member-search',
    templateUrl: './member-search.component.html',
    styleUrls: ['./member-search.component.scss'],
    standalone: false
})
export class MemberSearchComponent implements OnInit {
  @Input() allUsers: userInfo[] = []; //all available users of the organization
  @Input() allTeamUsers: User[] = [];
  @Input() editMembers: User[] = [];
  @Input() evalMembers: User[] = [];
  @Input() commentMembers: User[] = [];
  @Input() readMembers: User[] = [];
  @Input() adminMembers: User[] = [];
  @Input() allAvailableGroups: UserGroup[] = []; //all available groups of the organization
  @Input() editGroups: UserGroup[] = [];
  @Input() commentGroups: UserGroup[] = [];
  @Input() readGroups: UserGroup[] = [];
  @Input() projectLocked:boolean = false;
  @Input() autofocus:boolean = false;
  @Input() hideMembers:boolean = false;
  @Input() isGroupSearch:boolean = false;
  @Input() isUserSearch:boolean = false;
  @Input() canEditGroups:boolean = false;
  @Input() isAdding: boolean = false;
  @Input() applicationType: number = applicationType.assessment;
  @Output() addSignal: EventEmitter<User> = new EventEmitter<User>();
  @Output() addGroupSignal: EventEmitter<UserGroup> = new EventEmitter<UserGroup>();
  isSearching: boolean = false;
  searchWord: string = "";

  allIndividualUsers: User[] = []; //all individual team members
  allGroups: UserGroup[] = []; //all project Groups

  allUsersAvailable: searchUser[] = [];
  allGroupsAvailable: searchGroup[] = [];
  filteredUsers: searchUser[] = [];
  filteredGroups: searchGroup[] = [];

  hideWordSearched: boolean = false;


  constructor(private searchedUser: SearchedUserPipe) { }

  ngOnInit() {
    this.allIndividualUsers = this.editMembers.concat(this.readMembers, this.commentMembers, this.adminMembers);
    this.allGroups = this.editGroups.concat(this.readGroups, this.commentGroups);

    this.allUsers.forEach(userInfo => {
      let tempUser = new User(
        userInfo.member.profilePicture,
        userInfo.member.id,
        userInfo.member.name,
        userInfo.member.firstName,
        userInfo.member.lastName,
        userInfo.member.requestKey,
        userInfo.isInstitutionAdmin
      );
      tempUser.isEvaluator = this.userIsEvaluator(tempUser.member.requestKey);

      //find out if this is a team member (as an individual)
      let isMember = false;
      let foundUser = this.findUser(userInfo.member.requestKey);
      if( foundUser.length !== 0 ) {
        tempUser.individualAccess.allowComment = foundUser[0].individualAccess.allowComment;
        tempUser.individualAccess.allowEdit = foundUser[0].individualAccess.allowEdit;
        isMember = true;
      }
      let user:searchUser = {
        userData: tempUser,
        teamMember: isMember
      };
      if((isMember  && this.hideMembers)) {
        //skip this user
      } else if(tempUser.isEvaluator && this.isAdding){
        //skip the user
      }
      else {
        this.allUsersAvailable.push( user );
      }

      if(this.autofocus) {
        //focus search input
      }
    });

    this.allAvailableGroups.forEach( group => {
      let isInTeam = this.isGroupInTeam( group.guid );
      this.allGroupsAvailable.push( this.convertGroupToSearchGroup( group, isInTeam ) );
    });

    if( this.isAdding ) {
      this.search();
    }
  }

  userIsEvaluator(requestKey: string){
    return this.evalMembers.filter((user) =>{
      return user.member.requestKey.toLowerCase() === requestKey.toLowerCase();
    }).length !== 0;
  }

  search() {
    if(this.searchWord != '') {
      this.isSearching = true;
    } else {
      this.isSearching = false;
    }
    this.filteredUsers = [];
    this.filteredGroups = [];

    if(this.isUserSearch) {
      //filter users based on searchWord
      if( this.searchWord != '' ) {
        this.filteredUsers = this.searchedUser.transform( this.allUsersAvailable, this.searchWord );
      } else if( this.isAdding ) {
        this.filteredUsers =  this.filteredUsers.concat( this.allUsersAvailable );
      }

      //filter groups based on their users
      if( this.isGroupSearch ) {
        if( this.filteredUsers ) {
          this.filteredUsers.forEach( foundUser => {
            this.filteredGroups = this.findUserInGroup( foundUser.userData.member.requestKey );
          });
        }
      }
    }

    if( this.isGroupSearch ) {
      //search among groups, not individuals
      if( this.searchWord != '') {
        this.filteredGroups = this.findGroup( this.searchWord );
      } else if( this.isAdding ) {
        this.filteredGroups = this.filteredGroups.concat(this.allGroupsAvailable);
      }
    }

    if( this.isGroupSearch && !this.isUserSearch ) {
      this.hideWordSearched = true;
    }
  }

  convertGroupToSearchGroup(group:UserGroup, isInTeam: boolean) {
    return { groupData: group, teamMember: isInTeam };
  }

  addUser(member: User) {
    this.searchWord = '';
    this.isSearching = false;
    this.addSignal.emit(member);
  }
  addUserGroup(group: UserGroup) {
    this.searchWord = '';
    this.isSearching = false;
    this.addGroupSignal.emit(group);
  }

  findUser(requestKey: string) {
    return this.allIndividualUsers.filter((item: User ) => {
      return item.member.requestKey.toLowerCase() == requestKey.toLowerCase();
    });
  }

  closeSearch() {
    this.searchWord = "";
    this.isSearching = false;
    if( this.isAdding ) {
      this.search();
    }
  }

  findUserInGroup(requestKey: string) {
    return this.allGroupsAvailable.filter((group: searchGroup ) => {
      let foundMembers = group.groupData.members.filter((member: User) => {
        return member.member.requestKey.toLowerCase() == requestKey.toLowerCase();
      });
      if(foundMembers.length) {
        return true;
      }
    });
  }

  findGroup(searchText: string) {
    return this.allGroupsAvailable.filter((group: searchGroup ) => {
      return group.groupData.name.toLowerCase().includes(searchText.toLowerCase());
    });
  }

  isGroupInTeam(guid: string) {
    let found = false;
    this.allGroups.forEach(group=>{
      if( group.guid.toLowerCase() == guid.toLowerCase() ) {
        found = true;
      }
    });
    return found;
  }

}
interface userInfo {
  member: {
    profilePicture: string;
    id: number;
    name: string;
    firstName: string;
    lastName: string;
    requestKey: string;
  }
  isInstitutionAdmin: boolean;
}
interface searchUser {
  userData: User,
  teamMember: boolean
}
interface searchGroup {
  groupData: UserGroup,
  teamMember: boolean
}
